module.exports = __webpack_public_path__ + "static/media/themesInfo.c783716a.png";